import * as React from 'react';
import { PageChorinitia } from '../../genericComponents/Page/PageChorinitia';
import { UserRole } from '../../../types/UserRole';
import { Redirect } from 'react-router';
import { CourseForm } from './CourseForm';
import * as ReqType from '../../../types/ServerRequests';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import { CoursService } from '../../../services/CoursService';

/**
 * interface Props (le parametre de la classe)
 */
interface Props {
    /**
     * editable: boolean qui permet de passer de l'etat editable et non editable
     */
    editable: boolean;
}

/**
 * interface State (l'état interne de la classe CreateCourse)
 */
interface State {
    /**
     * redirect: permet de rediriger vers une autre page
     */
    redirect: boolean;
    /**
     * course: le course à creer
     */
    course: ReqType.Course;
}

/**
 * Ce composant permet de créer un cours (formulaire).
 * Il prend en paramétre un booleen qui determine si le formulaire est editable ou non.
 */
export class CreateCourse extends React.Component {

    /** le props: l'etat externe */
    props: Props;
    /** le state: l'etat interne */
    state: State;

    /**
     * construit la creation d'un cours
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            course: CoursService.getInstance().getDefaultCourse(),
            redirect: false,
        };
        // this.form = undefined;
    }

    /**
     * le rendu de la classe CreateCourse
     * @returns {JSX.element}
     */
    render() {
        if (this.state.redirect) {
            return <Redirect to={'/courses'} />;
        }
        return (
            <PageChorinitia allowedUsers={[UserRole.ADMIN]}>
                <div style={{paddingBottom: '20px'}}>
                    <CourseForm
                        disabled={false}
                        course={this.state.course}
                        setCourse={
                            (course: ReqType.Course) => {
                                this.setState({ course: course });
                            }
                        }
                    />
                    <LoaderButton
                        className="btn"
                        style={{marginLeft: '1cm', width: '3cm'}}
                        onClick={this.handleClick}
                    >
                        Valider
                    </LoaderButton>
                </div>
            </PageChorinitia>
        );
    }

    /**
     * create le nouveau cours contenu dans (this.state.course) et l'envois au backend
     * @returns {Promise<void>}
     */
    private handleClick = () => {
        return (CoursService.getInstance().createCours(this.state.course).then(
            () => {
                this.setState({ redirect: true });
            }
        ).catch(
            e => alert(JSON.stringify(e))
        ));
    }
}


// WEBPACK FOOTER //
// ./src/components/CoursesPage/internalComponents/CreateCourse.tsx